'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';
import { tinymce5 } from 'settings';

let settings = {
    fieldSelector: '.js-ajax-form__field',
    fieldNamePrefix: '.js-ajax-form__field--',
    contentSelector: '.js-ajax-form__content',
    messageSelector: '.js-ajax-form__message',
    errorClass: 'has-error',
    tinymce: tinymce5
};


class Form {
    constructor(el, options) {
        this.el = el;
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ Form/init ]', this.el);

        this.$form = $(this.el);
        this.$fields = this.opt.$fields || $(this.opt.fieldSelector, this.el);
        this.$content = this.opt.$content || $(this.opt.contentSelector).filter('[data-form_id="' + this.$form.data('form_id') + '"]');
        this.$message = this.opt.$message || $(this.opt.messageSelector, this.el);
        this.opt.skip_submit = this.$form.data('skip_submit') || this.opt.skip_submit;

        this._initFields();
        this._initEvents();

        //if ($.fancybox.isOpen) {
        //    $.fancybox.update();
        //}
    }
    submit() {
        console.log('[ Form/submit ]', this.el);

        if (!this.isLoading) {
            this._beforeSubmit();
            this._processSubmit();
            this._afterSubmit();
        }
    }
    _initFields() {
        let self = this;

        this.$fields.filter(this.opt.fieldNamePrefix + 'captcha').remove();
        /*$('input[type=file]').styler();*/

        if (typeof tinymce !== 'undefined') {
            tinymce.init(self.opt.tinymce);

            this.$form.find('textarea.mceEditor').each(function() {
                if (!window.__TINYMCE_COUNTER) { window.__TINYMCE_COUNTER = 1 }
                this.id = 'tinymce-' + window.__TINYMCE_COUNTER;
                window.__TINYMCE_COUNTER ++;
                let editor = new tinymce.Editor(this.id, self.opt.tinymce, tinymce.EditorManager);
                editor.render();

                if (this.required) {
                    this.required = false;
                }
            });
        }

        this.$fields.filter(self.opt.fieldNamePrefix + 'checkall').find('input').on('change', function(e) {
            e.preventDefault();
            let check = $(this).prop('checked');
            $(this).parents(self.opt.fieldSelector).find('input[type=checkbox]').prop('checked', check);
        });
    }
    _initEvents() {

        this.$fields.find(this.opt.fieldNamePrefix + 'file-del').on('click', function(e) {
            e.preventDefault();
            let $inp = $(this).parent().find('input[type=hidden]');
            $inp.clone().attr('type','file').attr('value','').insertAfter($inp);
            $inp.remove();
            $(this).siblings('a').remove();
            $(this).remove();
        });
        this.$fields.find('[type=file]').on('change', function(e) {
            $(this).parent().removeClass('has-error').find('.field__alert').remove();
            let max_file_size = $(this).data('max_file_size');
            if (max_file_size) {
                let file_size = $(this).get(0).files[0].size;
                console.log(file_size, max_file_size);
                if (file_size > max_file_size) {
                    $(this).val('');
                    $(this).parent().addClass('has-error');
                    $(this).parent().append('<div class="field__alert">Размер файла превышает ' + (max_file_size/1024) + 'кб. Выберите другой файл.</div>')
                }
            }
        });
        this.$form.on('submit', (e) => {
            if (typeof tinymce !== 'undefined') {
                tinymce.triggerSave();
            }
            if (!this.opt.skip_submit) {
                e.preventDefault();
                this.submit();
            }
        });
    }
    _beforeSubmit() {
        this.isLoading = true;

        this.$fields.removeClass(this.opt.errorClass);
        this.$message.hide();
        //$.fancybox.showLoading();
    }
    _processSubmit() {
        let params = new FormData(this.el);

        let action = this.$form.data('handler') || 'send_form';

        Ajax.get(action, params).then((data) => {
            if (data.ok) {
                console.log('[ Form/_processSubmit ] Sent successfully');

                if (this.$form.data('goal')) {
                    $(window).trigger('ajaxForm:form:goal', this.$form.data());
                }

                if (this.$content.length) {
                    this.$content.html(data.content);
                    this.$form.remove();
                } else {
                    this.$form.replaceWith(data.content);
                }
                this._afterSubmit();
            } else if (data.errors) {
                console.log('[ Form/_processSubmit ] Got errors', data.errors);

                for (let p in data.errors) {
                    console.log(this.opt.fieldNamePrefix + p);
                    console.log(this.$fields.filter(this.opt.fieldNamePrefix + p));
                    this.$fields.filter(this.opt.fieldNamePrefix + p).addClass(this.opt.errorClass);
                }
                if (data.errors.captcha) {
                    this.$fields.filter(this.opt.fieldNamePrefix + 'gcaptcha').addClass(this.opt.errorClass);
                    grecaptcha.ready(function () {
                        let _recaptcha = $('#recaptchaResponse').data('_recaptcha');
                        grecaptcha.execute(_recaptcha, { action: 'contact' }).then(function (token) {
                            var recaptchaResponse = document.getElementById('recaptchaResponse');
                            recaptchaResponse.value = token;
                        });
                    });
                }
                this._afterSubmit();
            }
            if (data.message) {
                this.$message.html(data.message).show();
            }
            if (data.reload) {
                window.location.reload();
            }
        }).catch(function(error) {
            console.error('[ Form/_processSubmit ] Sending failed', error);

            this._afterSubmit();
        });
    }
    _afterSubmit() {
        //$.fancybox.hideLoading();

        //if ($.fancybox.isOpen) {
        //    $.fancybox.update();
        //}

        this.isLoading = false;
    }
}


export {
    Form
};
